import _defineProperty from "/app/src/Web/InternetBranch/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
var _serializedInventoryI, _nonserializedInvento, _fixedasset;
/* eslint-disable */
export default {
  inventoryItemType: {
    taptitle: 'Envanter Türleri',
    refresh: 'Yenile',
    new: 'En Üst Seviye Ekle',
    actions: 'İşlemler',
    edit: 'Düzelt',
    newChilde: 'Alt Seviye Ekle',
    delete: 'Sil',
    formTitle: 'Envanter Türü',
    parentName: 'Üst Türü',
    name: 'Kod',
    title: 'Başlık',
    description: 'Açıklama',
    validationName: 'Ad 5 ile 250 karakter arasında olmalıdır',
    validationTitle: 'Başlık 5 ile 250 karakter arasında olmalıdır',
    validationDescription: 'Açıklama 5 ile 250 karakter arasında olmalıdır',
    requiredName: 'Ad girilmelidir',
    requiredTitle: 'Başlık girilmelidir',
    deleteQuestion: 'Envantör türünü silmek istediğinizden emim misiniz? ',
    errorLoadValues: 'Envanter listesi yüklenemedi'
  },
  fixedAssetType: {
    taptitle: 'Duran Varlık Türleri',
    refresh: 'Yenile',
    new: 'En Üst Seviye Ekle',
    actions: 'İşlemler',
    edit: 'Düzelt',
    newChilde: 'Alt Seviye Ekle',
    delete: 'Sil',
    formTitle: 'Duran Varlıklar',
    parentName: 'Üst Türü',
    name: 'Kod',
    title: 'Başlık',
    description: 'Açıklama',
    validationName: 'Ad 5 ile 250 karakter arasında olmalıdır',
    validationTitle: 'Başlık 5 ile 250 karakter arasında olmalıdır',
    validationDescription: 'Açıklama 5 ile 250 karakter arasında olmalıdır',
    requiredName: 'Ad girilmelidir',
    requiredTitle: 'Başlık girilmelidir',
    deleteQuestion: 'Duran varlık türünü silmek istediğinizden emim misiniz? ',
    errorLoadValues: 'Duran varlık listesi yüklenemedi',
    deleteLabel: 'Duran varlık silme onayı'
  },
  inventoryItem: {
    serializedInventoryItem: 'Envanter',
    nonserializedInventoryItem: 'Sarf Malzemesi',
    refresh: 'Yenile',
    new: 'Yeni'
  },
  serializedInventoryItem: (_serializedInventoryI = {
    remainedQuantity: 'Stok',
    statusType: 'Durum',
    itemType: 'Tür',
    comment: 'Açıklama',
    serialNumber: 'Seri No',
    partyName: 'Kullanıcı',
    allocatedDate: 'Zimmet Tarihi',
    assignmentComment: 'Atama Notu',
    actions: 'İşlemler',
    good: 'Sağlam',
    beingrepaired: 'Tamir Ediliyor',
    slightlydamaged: 'Hafif Hasarlı',
    defective: 'Arızalı',
    scrap: 'Hurda',
    inventoryItemTypeId: 'Tür',
    inventoryItemTypeIdPlaceholder: 'Envanter türünü seçiniz',
    inventoryItemStatusTypeId: 'Durum',
    inventoryItemStatusTypeIdPlaceholder: 'Envanter durumunu seçiniz'
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_serializedInventoryI, "partyName", 'Personel'), "assign", 'Atama'), "unassign", 'Zimmetten Düşürme'), "edit", 'Düzenle'), "delete", 'Sil'), "assignmentHistory", 'Zimmet tarihi'), "formTitle", 'Demişbaş'), "formTitleAssign", 'Demirbaş Zimmet '), "new", 'Yeni'), "inventoryItemTypeIdRequired", 'Türü seçiniz'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_serializedInventoryI, "inventoryItemStatusTypeIdRequired", 'Durumu seçiniz'), "serialNumberValidation", 'Seri numarası 5 ile 250 karakter arasında olmalıdır'), "serialNumberRequired", 'Seri numarası giriniz'), "deleteQuestion", 'Demirbaş kaydını silmek istediğinize emin misiniz?'), "deleteLabel", 'Demirbaş Silme Onayı'), "partyNameRequired", 'Personel adı gereklidir'), "partyNameValidation", 'Personel adı 5 ile 250 karakter arasında olmalıdır'), "commentValidation", 'Açıklama 5 ile 4000 karakter arasında olmalıdır'), "allocatedDateValidation", 'Zimmet tarihi girilmelidir'), "deleteAssignQuestion", 'Demirbaş zimmet kaydını silmek istediğinize emin misiniz?'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_serializedInventoryI, "deleteAssignLabel", 'Demirbaş Zimmet Silme Onayı'), "fromDate", 'Başlangıç'), "thruDate", 'Bitiş'), "allocateDate", 'Zimmet Tarihi'), "formAssignmentList", 'Zimmet Tarihi'), "actives", 'Aktifler'), "archives", 'Arşivler')),
  nonserializedInventoryItem: (_nonserializedInvento = {
    statusType: 'Durum',
    itemType: 'Tür',
    comment: 'Açıklama',
    allocatedDate: 'Zimmet Tarihi'
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_nonserializedInvento, "comment", 'Açıklama'), "remainedQuantity", 'Adet'), "partyName", 'Personel'), "serialNumber", 'Seri No'), "quantityOnHand", 'Adet'), "actions", 'İşlemler'), "good", 'Sağlam'), "beingrepaired", 'Tamir Ediliyor'), "slightlydamaged", 'Hafif Hasarlı'), "defective", 'Arızalı'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_nonserializedInvento, "scrap", 'Hurda'), "inventoryItemTypeId", 'Tür'), "inventoryItemTypeIdPlaceholder", 'Envanter türünü seçiniz'), "inventoryItemStatusTypeId", 'Durum'), "inventoryItemStatusTypeIdPlaceholder", 'Envanter durumunu seçiniz'), "edit", 'Düzenle'), "delete", 'Sil'), "formTitle", 'Demişbaş'), "formTitleAssign", 'Demirbaş Zimmet '), "new", 'Yeni'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_nonserializedInvento, "inventoryItemTypeIdRequired", 'Türü seçiniz'), "inventoryItemStatusTypeIdRequired", 'Durumu seçiniz'), "quantityOnHandRequired", 'Adet giriniz'), "deleteQuestion", 'Sarf malzemesi kaydını silmek istediğinize emin misiniz?'), "deleteLabel", 'Sarf Malzemesi Silme Onayı'), "commentValidation", 'Açıklama 5 ile 4000 karakter arasında olmalıdır'), "fromDate", 'Başlangıç'), "thruDate", 'Bitiş'), "actives", 'Aktifler'), "archives", 'Arşivler')),
  fixedasset: (_fixedasset = {
    fixedAssetType: 'Varlık Türü',
    name: 'Ad',
    comment: 'Açıklama',
    dateAcquired: 'Alınma Tarihi',
    dateLastService: 'Son Kullanım',
    dateNextService: 'Sıradaki Kullanım',
    quantityOnHand: 'Adet',
    actions: 'İşlemler',
    edit: 'Düzenle',
    delete: 'Sil',
    new: 'Yeni',
    refresh: 'Yenile'
  }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_fixedasset, "new", 'Yeni'), "actives", 'Aktifler'), "archives", 'Arşivler'), "fixedAssetTypeIdRequired", 'Varlık türünü seçiniz'), "dateAcquiredRequired", 'Alınma tarihini seçiniz'), "formTitle", 'Varlık'), "fixedAssetTypeIdPlaceholder", 'Varlık türünü seçiniz'), "nameRequired", 'Adı giriniz'), "nameValidation", 'Ad 5 ile 500 karakter arasında olmalıdır'), "deleteQuestion", 'Duran varlık kaydını silmek istediğinize emin misiniz?'), _defineProperty(_defineProperty(_fixedasset, "deleteLabel", 'Duran Valık Silme Onayı'), "assign", 'Kullanım Durumu Takvimi')),
  templateCode: {
    taptitle: 'Süreç Türleri',
    refresh: 'Yenile',
    new: 'Ekle',
    actions: 'İşlemler',
    edit: 'Düzelt',
    delete: 'Sil',
    formTitle: 'Süreç Türleri',
    templateType: 'Süreç Sınıfı',
    description: 'Açıklama',
    code: 'Kod',
    title: 'Başlık',
    validationName: 'Ad 5 ile 250 karakter arasında olmalıdır',
    validationtitle: 'Başlık 5 ile 250 karakter arasında olmalıdır',
    requiredtitle: 'Başlık girilmelidir',
    deleteQuestion: 'Süreç türünü silmek istediğinizden emim misiniz? ',
    requiredtemplateType: 'Süreç sınıfını seçiniz',
    errorLoadValues: 'Süreç türü listesi yüklenemedi',
    actives: 'Aktifer',
    archives: 'Arşivler',
    templateTypePlaceholder: 'Süreç sınıfı seçiniz',
    requiredcode: 'Kodu giriniz',
    validationcode: 'Kod 5 ile 250 karakter arasında olmalıdır.',
    formtemplate: 'Süreç Türleri',
    customer: 'Müşteri veya müşteriye sunulan hizmetle ilgili iş süreçi',
    command: 'Yazılımsal bir komut ile başlayan süreç -send sms, run query gibi-',
    event: 'Bir olaydan sonra başlayan süreç -ödeme sonrası mail gönder gibi-',
    organization: 'Kurumsal iş süreçleri',
    deleteLabel: 'Süreç türü silme onayı',
    employee: 'Çalışana sununal hizmetlere ait iş süreçleri'
  },
  performanceReviewItemType: {
    taptitle: 'Performans Kategorisi',
    refresh: 'Yenile',
    new: 'Ekle',
    actions: 'İşlemler',
    edit: 'Düzelt',
    delete: 'Sil',
    formTitle: 'Performans Kategorisi',
    description: 'Açıklama',
    name: 'Kod',
    title: 'Başlık',
    validationname: 'Kod 5 ile 250 karakter arasında olmalıdır',
    validationtitle: 'Başlık 5 ile 500 karakter arasında olmalıdır',
    validationdescription: 'Açıklama 5 ile 2000 karakter arasında olmalıdır',
    requiredtitle: 'Başlık girilmelidir',
    requiredname: 'Kod girilmelidir',
    deleteQuestion: 'Performans kategorisi silmek istediğinizden emim misiniz? ',
    errorLoadValues: 'Performans kategorisi listesi yüklenemedi',
    actives: 'Aktifer',
    archives: 'Arşivler',
    formtemplate: 'Performans Kategorisi',
    deleteLabel: 'Performans kategorisi silme onayı',
    mask: 'Mask',
    multiplier: 'Çarpan'
  },
  focus: {
    taskList: 'Görevlerim',
    processList: 'Taleplerim',
    timeSheet: 'Yapılan İşler',
    notifications: 'Bildirimler'
  },
  error: {
    InventoryItemTypeAlreadyDefinedWithSameName: 'Aynı isim ile tanımlı bir envanter türü mevcuttur.',
    FixedAssetTypeAlreadyDefinedWithSameName: 'Aynı isim ile tanımlı bir envanter türü mevcuttur.',
    TitleCodeAlreadyDefinedWithSameName: 'Aynı isim ile tanımlı bir süreç türü mevcuttur.'
  }
};